// extracted by mini-css-extract-plugin
export default {"BookRatingForm":"BookRatingForm_BookRatingForm__wD1dx","Stars":"BookRatingForm_Stars__lea+x"};